import React, { useEffect } from "react";
import PageTitle from "../../../Shared/PageTitle/PageTitle";
import BlogList from "./components/BlogList";
import "./OtherAccesoires.css";

const OtherAccesoires = () => {
  useEffect(() => {
    window.scrollTo(10, 0);
  }, []);

  return (
    <>
      <PageTitle title={"Accesoires"} currentPage={"Accesoires"} />
      <BlogList />
    </>
  );
};

export default OtherAccesoires;
